import { Action, Reducer } from 'redux';
import { SearchFilter } from '../components/ChaptersBlogListingResult';
import { AppThunkAction } from './';

export interface IState {
    filter: SearchFilter;
    categoryId: string;
}

export enum Actions {
    SetFilter = "SET_FILTER",
    SetCategory = "SET_CATEGORY"
}

interface SetCategoryFilterAction {
    type: Actions.SetCategory;
    categoryId: string;
}

interface SetSearchFilterAction {
    type: Actions.SetFilter;
    filter: SearchFilter;
}

type KnownAction = SetSearchFilterAction | SetCategoryFilterAction;


export const actionCreators = {
    setFilter :(filter: SearchFilter): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: Actions.SetFilter, filter });
    },
    setCategory: (categoryId: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: Actions.SetCategory, categoryId });
    }
}

const unloadedState: IState = {
    filter: {
        Category: '',
        Keywords: '',
        Path: '/%',
        SortByField: 'date',
        YearMonth: '',
        SortASC: false
    },
    categoryId: undefined
};

export const reducer: Reducer<IState> = (state: IState | undefined, incomingAction: Action): IState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {

        case Actions.SetCategory:

            console.log('ChaptersBlogStore: SetCategory received', action.categoryId);

            return {
                ...state,
                categoryId: action.categoryId
            };       

        case Actions.SetFilter:

            console.log('ChaptersBlogStore: new searchfilter received', action.filter);

            return {
                ...state,
                filter: action.filter
            };  

        default:
            return state;    
    }
};